import React, { useEffect, useRef } from "react";
import Vimeo from "@u-wave/react-vimeo";

interface VideoFullScreenProps {
  elementId?: string;
  url?: string;
}

const VideoFullScreen: React.FC<VideoFullScreenProps> = ({
  elementId = "",
  url,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const applyStyles = () => {
      const iframeEl = containerRef.current?.querySelector("iframe");
      if (iframeEl) {
        iframeEl.removeAttribute("height");
        iframeEl.removeAttribute("width");
        iframeEl.style.width = "100%";
        iframeEl.style.height = "auto";
        iframeEl.style.aspectRatio = "16 / 9";
        iframeEl.style.minHeight = "0";
        iframeEl.style.display = "block";
      }
    };
    applyStyles();
    // Vimeo loads async — retry until iframe appears
    const timer = setInterval(() => {
      if (containerRef.current?.querySelector("iframe")) {
        applyStyles();
        clearInterval(timer);
      }
    }, 100);
    return () => clearInterval(timer);
  }, [url]);

  return (
    <div
      ref={containerRef}
      id={elementId}
      className="embed-responsive embed-responsive-16by9"
      style={{ lineHeight: 0, width: "100%" }}
    >
      {url && url !== "" ? (
        <Vimeo
          autoplay
          autopause={false}
          controls={false}
          loop
          muted
          video={url}
          style={{ width: "100%" }}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default VideoFullScreen;
